(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-clock-feature"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-clock-feature-videos]').forEach(function (section) {
    section.querySelectorAll('.lyt-item').forEach(function (item) {
      var videoDesktop = item.querySelector('video.__is_desktop819');
      var videoMobile = item.querySelector('video.__is_mobile819');
      var playBtn = item.querySelector('.__movie-play');
      var volBtn = item.querySelector('.__movie-volume');

      [videoDesktop, videoMobile].forEach(function (v) {
        if (!v) return;
        v.muted = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.preload = 'metadata';
      });

      function activeVideo() {
        return window.innerWidth <= 640 ? videoMobile : videoDesktop;
      }

      var userPaused = false;

      function setPlayLabel(isPaused) {
        if (!playBtn) return;
        var label = playBtn.getAttribute('data-video-label') || '';
        if (label) playBtn.setAttribute('aria-label', (isPaused ? 'Play ' : 'Pause ') + label);
      }

      function setVolLabel(isMuted) {
        if (!volBtn) return;
        var label = volBtn.getAttribute('data-video-label') || '';
        if (label) volBtn.setAttribute('aria-label', (isMuted ? 'Unmute ' : 'Mute ') + label);
      }

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var video = activeVideo();
          if (!video) return;
          if (video.paused) {
            userPaused = false;
            video.play().catch(function () {});
            playBtn.classList.remove('__active');
            setPlayLabel(false);
          } else {
            userPaused = true;
            video.pause();
            playBtn.classList.add('__active');
            setPlayLabel(true);
          }
        });
      }

      if (volBtn) {
        volBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var video = activeVideo();
          if (!video) return;
          if (video.muted) {
            video.muted = false;
            volBtn.classList.add('__active');
            setVolLabel(false);
          } else {
            video.muted = true;
            volBtn.classList.remove('__active');
            setVolLabel(true);
          }
        });
      }

      function observe(video) {
        if (!video || typeof IntersectionObserver === 'undefined') return;
        var pauseTimer = null;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
              if (pauseTimer) { clearTimeout(pauseTimer); pauseTimer = null; }
              if (userPaused) return;
              if (video.paused) video.play().catch(function () {});
            } else if (!pauseTimer) {
              pauseTimer = setTimeout(function () {
                if (!video.paused) video.pause();
                pauseTimer = null;
              }, 300);
            }
          });
        }, { threshold: [0, 0.35, 0.6] });
        io.observe(video);
      }
      observe(videoDesktop);
      observe(videoMobile);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
